import { useLocation } from 'react-router-dom';

/**
 * A hook to get the query params from the url.
 * See: https://reactrouter.com/web/example/query-parameters
 * */
const useQueryParams = () => new URLSearchParams(useLocation().search);

export default useQueryParams;
